import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link, useParams } from "react-router-dom"

import { selectScopedByClient } from "../../stores/appSlice"
import { fetchChannelPartner, selectChannelPartner } from "./channelPartnersSlice"

export default function ChannelPartnerNav({ activeTab, scopedBychannelPartner = false }) {
    const dispatch = useDispatch()
    const { clientId, channelPartnerId } = useParams()
    const channelPartner = useSelector(selectChannelPartner)
    const scopedByClient = useSelector(selectScopedByClient)

    // Fetch the channelPartner we need for breadcrumb
    // TODO: we may be able to simply swap this out for the use selector based
    // on how we decide to finally load in the records from other components.
    useEffect(() => {
        if (channelPartnerId) {
            dispatch(fetchChannelPartner(channelPartnerId))
        }
    }, [dispatch, channelPartnerId])

    const formatRoute = (newRoute) => {
        if (clientId) {
            if (channelPartnerId && scopedBychannelPartner) {
                return `/clients/${clientId}/channelPartners/${channelPartnerId}${newRoute}`
            } else {
                return `/clients/${clientId}/channelPartners${newRoute}`
            }
        } else if (channelPartnerId) {
            return `/channelPartners/${channelPartnerId}${newRoute}`
        }

        return `/channelPartners${newRoute || ""}`
    }

    // If we are scoped by a client, we are looking at an end-user's view.
    // If we are not scoped by a client, we are looking at an admin's view.
    const renderHeader = () => {
        if (scopedByClient) {
            return scopedBychannelPartner ? renderRecordHeader() : renderIndexHeader()
        }

        // Admin - Not scoped by client here
        return (
            <>
                <h2>Channel Partners</h2>
                <ul className="header-tab-nav" role="navigation">
                    <li>
                        <Link to={() => formatRoute("/")}>
                            <button type="link" className={`${activeTab === "list" ? "selected" : ""}`}>
                                All Channel Partners
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    const renderRecordHeader = () => {
        return (
            <>
                <h2>{`channelPartners > ${channelPartner.name}`}</h2>
                <ul className="header-tab-nav" role="navigation">
                    <li>
                        <Link to={() => formatRoute("/dashboard")}>
                            <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                                Dashboard
                            </button>
                        </Link>
                    </li>

                    <li>
                        <Link to={() => formatRoute("/bills")}>
                            <button type="link" className={`${activeTab === "bills" ? "selected" : ""}`}>
                                ChannelPartners bills
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    const renderIndexHeader = () => {
        return (
            <>
                <h2>ChannelPartners</h2>
                <ul className="header-tab-nav" role="navigation">
                    <li>
                        <Link to={() => formatRoute("/dashboard")}>
                            <button type="link" className={`${activeTab === "dashboard" ? "selected" : ""}`}>
                                ChannelPartners Dashboard
                            </button>
                        </Link>
                    </li>
                    <li>
                        <Link to={() => formatRoute("")}>
                            <button type="link" className={`${activeTab === "list" ? "selected" : ""}`}>
                                ChannelPartners List
                            </button>
                        </Link>
                    </li>
                </ul>
            </>
        )
    }

    return <>{renderHeader()}</>
}
